import React from "react";
import '../../styles/components/settings/settings-page.scss';
import SettingsMenu from "./SettingsMenu";
import KeyboardAndVolumes from "./KeyboardAndVolumes";
import AccountSection from "./AccountSection";
import AboutSection from "./AboutSection";
import TabbedNavigation from "../tabbedNavigation/TabbedNavigation";
import deviceInfo from "../../services/deviceInfo/deviceInfo";
import {useAppSelector} from "../../redux/hooks";
import {settingsPageStore} from "../../redux/settingsPage/settingsPageStore";
import {SettingsPageSection} from "../../redux/settingsPage/settingsPageTypes";
import PrivacySection from "./PrivacySection";

interface ISettingsPageProps {
}

export default function SettingsPage({}: ISettingsPageProps) {
  const selectedSection = useAppSelector(settingsPageStore.getSelectedSection);
  const settingsDesktopHeader = deviceInfo.getIsDesktop() ? <div className="settings-desktop-header">Settings</div> : null;
  const SettingsSectionComponent = getSettingsSectionComponent(selectedSection);

  return (
    <div className="settings-page">
      {settingsDesktopHeader}
      <SettingsMenu/>
      <SettingsSectionComponent/>
      <footer className="footer">
        <TabbedNavigation/>
      </footer>
    </div>

  );
}

function getSettingsSectionComponent(selectedSection: SettingsPageSection){
  switch (selectedSection) {
    case "myAccount":
      return AccountSection;
    case "keyboardAndVolumes":
      return KeyboardAndVolumes;
    case "about":
      return AboutSection;
    case "privacy":
      return PrivacySection;
    default:
      throw new Error(`Invalid settings section: ${selectedSection}`);
  }
}